import { Outlet } from "react-router-dom";
import { LanguageProvider } from "../hooks/use-language/use-language";

export default function AuthLayout() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0">
        {/* SVG Background */}
        <img
          src="/assets/icons/auth-background.svg"
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />

        {/* Gradient overlay for depth */}
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/40 via-blue-600/30 to-indigo-700/40" />
      </div>

      {/* Content layer */}
      <div className="relative z-10 flex min-h-screen flex-col items-center gap-6 p-4 pt-14 text-white sm:gap-8 sm:pt-16 md:gap-10 md:pt-20">
        {/* Glassmorphism card */}
        <div className="flex flex-col items-center gap-2 text-normal sm:gap-3">
          <div className="flex items-center gap-3">
            <img
              src="/assets/icons/vidyapeeth-logo.svg"
              alt="Vidyapeeth Logo"
              className="h-14 w-auto sm:h-14"
            />
            <span
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 700,
                fontSize: "24px",
                lineHeight: "32px",
                color: "white",
              }}
            >
              VIDYAPEETH
            </span>
          </div>
          <span className="text-body text-center text-white/80">
            Learn Smarter. Grow Faster
          </span>
        </div>

        <div className="w-full max-w-[min(100%,26rem)] rounded-2xl border border-white/20 bg-white/10 px-5 py-6 shadow-2xl backdrop-blur-md sm:max-w-[28rem] sm:px-6 sm:py-7 md:max-w-[34.5rem] md:px-8 md:py-8 xl:max-w-[40rem] xl:px-10">
          <LanguageProvider>
            <Outlet />
          </LanguageProvider>
        </div>
      </div>
    </div>
  );
}
